import { render, staticRenderFns } from "./file_view.vue?vue&type=template&id=53115e7a&scoped=true&"
import script from "./file_view.vue?vue&type=script&lang=ts&"
export * from "./file_view.vue?vue&type=script&lang=ts&"
import style0 from "./file_view.vue?vue&type=style&index=0&id=53115e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53115e7a",
  null
  
)

export default component.exports